import type { HistoryDateFilter, HistoryDateFilterItem } from '@/shared/types';

const PREFERRED_DATE_FILTER: HistoryDateFilter = 'last30d';

const getDefaultDateFilter = (
  items: HistoryDateFilterItem[] | undefined
): HistoryDateFilter | undefined => {
  if (!items?.length) return undefined;

  const preferred = items.find(
    item => item.datefilter === PREFERRED_DATE_FILTER
  );

  return preferred?.datefilter ?? items[0].datefilter;
};

export { getDefaultDateFilter };
